import { Controller } from "@hotwired/stimulus"
import jsonview from '@pgrabovets/json-view';

export default class extends Controller {
  connect() {
    var data = this.element.getAttribute("data-json");
    const tree = jsonview.create(data);
    const treeDiv = document.createElement("div");
    this.element.appendChild(treeDiv);
    jsonview.render(tree, treeDiv);
    if (this.element.hasAttribute("data-expand")) {
      jsonview.expand(tree);
    }
  }
}
